<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="txbxshortName">Job</label>
                    <wj-combo-box
                        [(ngModel)]="target.job"
                        name="job"
                        [isRequired]="true"
                        [itemsSource]="jobMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group">
                    <label for="txbxDept">Department</label>
                    <wj-combo-box
                        [(ngModel)]="target.departmentId"
                        name="departmentId"
                        [isRequired]="true"
                        [itemsSource]="departmentMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="txbxName">Task Name</label>
                    <input id="txbxName" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-3">
                <div class="form-group">
                    <label for="priority">Task Priority</label>
                    <input
                        id="priority"
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.priority"
                        name="priority"
                        min="1"
                        max="20"
                    />
                </div>
            </div>

            <div class="col-3">
                <div class="form-group">
                    <label for="phasePriority">Phase Priority</label>
                    <input
                        id="phasePriority"
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.phasePriority"
                        name="phasePriority"
                        min="1"
                        max="20"
                    />
                </div>
            </div>

            <div class="col-3">
                <div class="form-group">
                    <label for="estimatedStartDate">Estimated Start</label>
                    <wj-input-date
                        id="estimatedStartDate"
                        [(ngModel)]="target.estimatedStartDate"
                        name="estimatedStartDate"
                        [selectionMode]="'Month'"
                        [format]="'MMMM yyyy'"
                        [isRequired]="false"
                    ></wj-input-date>
                </div>
            </div>

            <div class="col-3">
                <div class="form-group">
                    <label for="estimatedHours">Estimated Hours</label>
                    <input
                        id="estimatedHours"
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.estimatedHours"
                        name="estimatedHours"
                    />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="crewAssignment">Crew Assignment</label>
                    <input id="crewAssignment" type="text" class="form-control" [(ngModel)]="target.crewAssignment" name="crewAssignment" />
                </div>
            </div>

            <div class="col-3">
                <div class="form-group">
                    <label for="txbxshortName">Site Ready</label>
                    <wj-combo-box
                        [(ngModel)]="target.siteReady"
                        name="siteReady"
                        [isRequired]="true"
                        [itemsSource]="boolMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>

            <div class="col-3">
                <div class="form-group">
                    <label for="materialsReady">Materials Ready</label>
                    <wj-combo-box
                        id="materialsReady"
                        [(ngModel)]="target.materialsReady"
                        name="materialsReady"
                        [isRequired]="true"
                        [itemsSource]="boolMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="materialsNeeded">Materials Needed</label>
                    <input
                        id="materialsNeeded"
                        type="text"
                        class="form-control"
                        [(ngModel)]="target.materialsNeeded"
                        name="materialsNeeded"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
